import { render, staticRenderFns } from "./directDeliveryOrderList.vue?vue&type=template&id=f82eec3c&scoped=true"
import script from "./directDeliveryOrderList.vue?vue&type=script&lang=js"
export * from "./directDeliveryOrderList.vue?vue&type=script&lang=js"
import style0 from "./directDeliveryOrderList.vue?vue&type=style&index=0&id=f82eec3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82eec3c",
  null
  
)

export default component.exports